
// src/api/toDoApi.js
import apiClient from './axios';

const toDoApi = {
  // Tasks
   getAll: (page = 1, pageSize = 10, search = '', type = "", start_date = "", end_date = "", date_range = "", status = "") =>
    apiClient.get('/todo/tasks', { 
      params: { 
        page, 
        page_size: pageSize, 
        search, 
        type,
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(date_range && { date_range }),
        ...(status && { status }),
      } 
    }).then(r => r.data),

  // create: (formData) =>
  //   apiClient.post('/todo/tasks', formData).then(r => r.data),

  // In toDoApi.js
create: (formData) => {
  // Let axios/the browser set Content-Type itself: a FormData body needs the
  // boundary the browser generates (multipart/form-data; boundary=...). Setting
  // it manually to a bare "multipart/form-data" here strips that boundary, so the
  // body no longer matches its own declared Content-Type — the request either
  // fails to reach the server cleanly (net::ERR_FAILED) or the server can't
  // parse the body at all.
  return apiClient.post('/todo/tasks', formData).then(r => r.data);
},

update: (id, formData) =>
    // X-HTTP-Method-Override tells the backend's Laravel-compat middleware to treat
    // this POST as PUT (multipart PUT is awkward for browsers) — that part is correct
    // and required. Content-Type is intentionally left for axios to set (see `create`).
    apiClient.post(`/todo/tasks/${id}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' },
    }).then(r => r.data),

  delete: (id) => apiClient.delete(`/todo/tasks/${id}`),

  // Cards/Overview view: paginated category cards (General Tasks + Projects), each
  // with its full task list nested — replaces the old page_size=10000 pull.
  getCategories: (page = 1, pageSize = 10, search = '', type = '', categoryType = '') =>
    apiClient.get('/todo/tasks/categories', {
      params: {
        page,
        page_size: pageSize,
        search,
        type,
        ...(categoryType && { category_type: categoryType }),
      }
    }).then(r => r.data),

  exportCsv: () =>
    apiClient.get('/todo/tasks/export', { responseType: 'blob' }).then(r => r.data),

  // Projects
  getProjects: () => apiClient.get('/todo/projects').then(r => r.data),
  createProject: (data) => apiClient.post('/todo/projects', data).then(r => r.data),
  updateProject: (id, data) => apiClient.put(`/todo/projects/${id}`, data).then(r => r.data),
  deleteProject: (id) => apiClient.delete(`/todo/projects/${id}`),

  // Labels
  // getLabels: (type = "") => apiClient.get('/todo/labels', { params: { type } }).then(r => r.data),
  // In toDoApi.js - update the getLabels function:

getLabels: (type = "", employee_id = "") => 
  apiClient.get('/todo/labels', { 
    params: { 
      type,
      ...(employee_id && employee_id !== "" && { employee_id }) // ← Only add if exists
    } 
  }).then(r => r.data),

  getLabelsAll: (type = "", employee_id = "") => 
  apiClient.get('/todo/labels', { 
    params: { 
      type,
      ...(employee_id && employee_id !== "" && { employee_id }) // ← Only add if exists
    } 
  }).then(r => r.data),
  
  createLabel: (data) => apiClient.post('/todo/labels', data).then(r => r.data),
  updateLabel: (id, data) => apiClient.put(`/todo/labels/${id}`, data).then(r => r.data),
  deleteLabel: (id) => apiClient.delete(`/todo/labels/${id}`),
};

export default toDoApi;